import http from "@/utils/http";
import { MessageBox, Message } from "element-ui";
import store from '@/vuex/store';
import JSZip from 'jszip'
import { saveAs } from 'file-saver'
import util from "@/utils/util";

export const magicApi = {
  // 设置魔术贴
  setBackDoor: (val) => {
    store.commit('setBackDoor', val)
    return 'yanfa3: 注意操作的谨慎性、保密性'
  },
  closeExam: (params) => {
    return magicConfirm().then(result => {
      if (result === 'confirm') {
        return http.put('/marking-exam-grading/grading-status/finish/forced', params, 'form')
      } else {
        return { code: -1, message: '操作取消' }
      }
    })
  },
  recoverMarking: (params) => {
    return magicConfirm().then(result => {
      if (result === 'confirm') {
        return http.post('/marking-exam-grading/grading-status/recover', params)
      } else {
        return { code: -1, message: '操作取消' }
      }
    })
  },
  getExamPapers: (examIds, schoolId) => {
    return magicConfirm().then(result => {
      if (result === 'confirm') {
        return http.post('/marking-exam-manager/student-paper/exam-result/by-examIds?schoolId=' + schoolId, examIds)
      } else {
        return { code: -1, message: '操作取消' }
      }
    })
  },
  // 获取异常卷集合
  getAbnormalTestPaper: (examId) => {
    return magicConfirm().then(result => {
      if (result === 'confirm') {
        return http.post(`/marking-exam-manager/exam/${examId}/doubt/search-all-paper?haveCheck=true`)
      } else {
        return { code: -1, message: '操作取消' }
      }
    })
  },
  allMarkDoubt: (schoolId, code, type) => {
    return magicConfirm().then(result => {
      if (result === 'confirm') {
        return http.put(`/marking-exam-manager/exam/mark_doubt?schoolId=${schoolId}&code=${code}${util.isEmpty(type) ? '' : `&type=${type}`}`)
      } else {
        return { code: -1, message: '操作取消' }
      }
    })
  },
  downloadZip: async (images, folderName) => {
    const zip = new JSZip()
    const folder = zip.folder(folderName)
    const promises = []
    for (let index = 0; index < images.length; index++) {
      const image = images[index];
      const data = await http.download(image)
      if (!data) continue
      // 获取图片名
      const name = image.split('/')[image.split('/').length - 1]
      folder.file(name, data, { binary: true })
      if (index % 100 === 0) {
        Message.info(`已下载：${index + 1}/${images.length}`)
      }
    }
    zip.generateAsync({ type: 'blob', streamFiles: true }).then(content => {
      saveAs(content, folderName + '.zip')
      Message.warning({
        message: images.length + '份下载完成！2s后会自动刷新，释放内存空间',
        onClose: () => {
          location.reload()
        }
      })
    })
  },
  downloadExamResult (examId, schoolId, isRawScore = false) {
    return magicConfirm().then(result => {
      if (result === 'confirm') {
        return http.get('/marking-exam-manager/student-score/excel/template_use_long_task', { examId, schoolId, isRawScore, isUpload: true })
      } else {
        return { code: -1, message: '操作取消' }
      }
    })
  },
  checkLongTask (id) {
    return http.get('/marking-platform/long-task/' + id)
  },
  reNewStudent (examId) {
    return magicConfirm().then(result => {
      if (result === 'confirm') {
        return http.post('/marking-exam-manager/quick-repair-student?examId=' + examId, {})
      } else {
        return { code: -1, message: '操作取消' }
      }
    })
  },
  markingFlow (params) {
    return http.get('/marking-exam-grading/stream/len', params)
  },
  markingDetail (params) {
    return http.post('/marking-exam-grading/stream/detail', params)
  }
}

function magicConfirm () {
  return MessageBox.confirm(`内部操作需谨慎，是否确定操作？`, '小博士提示', { type: 'warning' })
    .catch(() => { }).finally(() => {
      magicApi.setBackDoor(false)
    })
}